import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import store from "./app/store";
import reportWebVitals from "./reportWebVitals";
import { loadStaticManifest } from "./utils/staticImages";

import "bootstrap/dist/js/bootstrap.bundle.min.js";

window.store = store;


const root = ReactDOM.createRoot(document.getElementById("app"));

const renderApp = (key) =>
  root.render(
    <Provider key={key} store={store}>
      <App />
    </Provider>
  );

// Static CDN images are read while rendering, so the manifest must be there first:
// instant from the cached copy, otherwise wait briefly (the images fall back to blank if it never arrives).
const staticManifest = loadStaticManifest();
if (staticManifest.fromCache) {
  renderApp(0);
  // the live manifest changed since the cached one: remount once so new images show up
  staticManifest.fresh.then((data) => {
    if (data?.version && data.version !== staticManifest.cachedVersion) renderApp(1);
  });
} else {
  Promise.race([staticManifest.fresh, new Promise((resolve) => setTimeout(resolve, 2000))]).then(() =>
    renderApp(0)
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals();
